import React, {
    useState,
    useEffect,
} from "react";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { editCellContainerStyle } from "../onBoardingMaterialIdSetup/constant";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import {
    gridStyles,
    gridComponents,
} from "../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { AGridColDef } from "../../../../common/data-grid/ADataGridColDef";

const ReleaseStatListing = ({ rows, loading = false }) => {
    const [releaseRowData, setReleaseRowData] = useState(rows);

    useEffect(() => {
        setReleaseRowData(rows);
    }, [rows]);

    const columns = [
        new AGridColDef("Code", "Code", false)
            .setMinWidth(80)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={params}
                        placeholder={""}
                    />
                </div>
            )),
        new AGridColDef("Description", "Description", false)
            .setMinWidth(80)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={''}
                        placeholder={""}
                    />
                </div>
            )),
        new AGridColDef("Processor", "Processor", false)
            .setMinWidth(80)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={''}
                        placeholder={""}
                    />
                </div>
            )),
        new AGridColDef("Status", "Status", false)
            .setMinWidth(80)
            .setFlex(1)
            .editable(true)
            .setValueGetter((params) => params?.value)
            .renderEditCellComponent((params) => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={''}
                        placeholder={""}
                    />
                </div>
            )),

    ];

    return (
        <>
            <div
                className=""
                style={{ border: "1px solid #EEE", borderRadius: "8px" }}
            >
                <ADataGrid
                    removeWrapperContainer
                    sx={{
                        ...gridStyles,
                    }}
                    rows={releaseRowData}
                    columns={columns}
                    rowId={(row) => row.id}
                    rowHeight={50}
                    loading={false}
                    maxHeight={"300px"}
                    rowCount={(releaseRowData || []).length}
                    hidePagination
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loading ? "Loading..." : null} />
                        ),
                    }}
                />
            </div>
        </>
    )
}

export default ReleaseStatListing;   